import { Component, OnInit, AfterViewInit } from '@angular/core';

declare var jquery: any;
declare var $: any;

@Component({
  selector: 'app-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.css']
})



export class SidenavComponent implements OnInit, AfterViewInit {

  constructor() { }

  ngOnInit() {

  }

  ngAfterViewInit() {
    $('.nav>li>a').click(function () {
      $(this).addClass("active");
    });
  }

  isAdmin() {
    let userInfo: any = JSON.parse(sessionStorage.currentUser);
    if (userInfo.admin == null || userInfo.admin == false)
      return false;
    else
      return true;
  }

  isUserInternal() {
    let userInfo: any = JSON.parse(sessionStorage.currentUser);
    if (userInfo.externalUser == null || userInfo.externalUser == true)
      return false;
    else
      return true;
  }

}



// WEBPACK FOOTER //
// ./src/app/home/sidenav/sidenav.component.ts